import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, filter, map, of, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SvgIconService {
  private readonly iconCache = new Map<string, string>();
  private readonly iconLoadingHeap = new Set<string>();
  private readonly loadingStream$ = new Subject<IconStreamItem>();

  constructor(private readonly httpClient: HttpClient) {}

  getIcon(iconName: string): Observable<string> {
    const cachedIcon = this.iconCache.get(iconName);
    if (cachedIcon) {
      return of(cachedIcon);
    }
    const isIconAlreadyLoading = this.iconLoadingHeap.has(iconName);
    this.iconLoadingHeap.add(iconName);

    return isIconAlreadyLoading
      ? this.loadingStream$.pipe(
          filter((iconItem) => iconItem.iconName === iconName),
          map((iconItem) => iconItem.rawValue),
          take(1)
        )
      : this.httpClient
          .get(`assets/icon/${iconName}.svg`, {
            responseType: 'text',
          })
          .pipe(
            tap((rawValue) => {
              this.iconCache.set(iconName, rawValue);
              this.iconLoadingHeap.delete(iconName);
              this.loadingStream$.next({
                iconName,
                rawValue,
              });
            })
          );
  }
}

type IconStreamItem = {
  iconName: string;
  rawValue: string;
};
